import type {SyncIntegration} from '@cohort/merchants/apps';
import ShopifySyncConfigComponent from '@cohort/merchants/apps/shopify/sync/SyncConfigComponent';
import type {ShopifySyncStruct} from '@cohort/shared/apps/shopify/sync';
import {ShopifySyncIntegrationSpec} from '@cohort/shared/apps/shopify/sync';

export const ShopifySyncIntegration: SyncIntegration<ShopifySyncStruct> = {
  spec: ShopifySyncIntegrationSpec,
  syncConfigComponent: ShopifySyncConfigComponent,
};
